import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { Suspense } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LayoutTemplate } from 'signup-components/components/LayoutTemplate/LayoutTemplate';
import { LayoutType } from 'signup-components/types';
import styled from 'styled-components';
import { getCurrentStepNumbering } from '../flow-management/stepNumberingSelectors';
import { useCanGoBack } from '../hooks/useCanGoBack';
import { useCurrentStep } from '../hooks/useCurrentStep';
import { getLoginUrl } from '../http-login/getLoginUrl';
import { useResponsiveness } from '../responsiveness/ResponsivenessProvider';
import { getHaveAnAccountMessage } from '../step-landing-page/HaveAnAccountLink';
import { getLoginRedirectUrl } from '../step-landing-page/getLoginRedirectUrl';
import { goPrevStep } from '../store/flow/action-creators';
import { useTracker } from '../tracking/useTracker';
import { getSpecificLogoConfig } from '../views-components/HubSpotLogo';
import { Step } from '../views/Step';
import { getStepConfig } from '../views/getStepConfig';
import { AppMessagingComponent } from './AppMessagingComponent';
import { TrackWhen, useExperiment } from '../experiments/useExperiment';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../experiments/ExperimentParameterGroup';
export const MessagingAboveStepContentContainer = styled.div.withConfig({
  displayName: "LayoutTemplateViewContainer__MessagingAboveStepContentContainer",
  componentId: "sc-2v1f13-0"
})(["display:flex;justify-content:center;"]);
export const LayoutTemplateViewContainer = (_ref) => {
  let {
    StepViewComponent
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["StepViewComponent"]);

  const {
    currentStep
  } = useCurrentStep();
  const loginRedirectUrl = getLoginRedirectUrl();
  const {
    canGoBack,
    completedStep
  } = useCanGoBack();
  const dispatch = useDispatch();
  const {
    currentStep: currentStepNumber,
    totalSteps
  } = useSelector(getCurrentStepNumbering);
  const Tracker = useTracker();
  const {
    isMobile
  } = useResponsiveness();
  const {
    url,
    altText
  } = getSpecificLogoConfig(isMobile);
  const stepConfig = getStepConfig(currentStep);
  const showMessagingAboveContent = stepConfig && stepConfig.showMessagingAboveContent;
  const {
    isAssignedToSpecificVariant: isAssignedToSpecificVariantACQ134
  } = useExperiment(ExperimentKeys.ACQ0134, TrackWhen.never);
  const shouldShowBackLink = Boolean(canGoBack && completedStep);

  const onBackLinkClick = event => {
    event.preventDefault();
    Tracker.backButton(currentStep, completedStep);
    dispatch(goPrevStep());
  };

  const onAccountLinkClick = () => {
    Tracker.signupInteraction('click-login-have-an-account', {}, true);
    Tracker.redirect({
      url: 'https://app.hubspot.com/login'
    });
  };

  const onLogoClick = () => {
    Tracker.signupInteraction('click-hubspot-company-logo', {
      currentStep
    }, true);
  };

  const renderMessagingAboveStepContent = () => {
    if (showMessagingAboveContent) {
      return /*#__PURE__*/_jsx(MessagingAboveStepContentContainer, {
        children: /*#__PURE__*/_jsx(AppMessagingComponent, {})
      });
    }

    return null;
  };

  const shouldShowAccountLink = isAssignedToSpecificVariantACQ134(ExperimentParameterGroup.Variant_B) ? currentStep === Step.Industry : currentStep === Step.LandingPage;
  return /*#__PURE__*/_jsx("div", Object.assign({}, props, {
    children: /*#__PURE__*/_jsxs(LayoutTemplate, {
      accountLinkHref: getLoginUrl({
        redirectUrl: loginRedirectUrl
      }),
      accountLinkMessage: getHaveAnAccountMessage(),
      alignCentredStepAtTheTop: true,
      currentStepNumber: currentStepNumber,
      layoutType: LayoutType.CentredStep,
      logoAltText: altText,
      logoImageSrc: url,
      showBackLink: shouldShowBackLink,
      showHaveAnAccountLink: shouldShowAccountLink,
      showLogo: true,
      showManageCookiesLink: true,
      showProgressIndicator: true,
      totalSteps: totalSteps,
      onAccountLinkClick: onAccountLinkClick,
      onBackLinkClick: onBackLinkClick,
      onLogoClick: onLogoClick,
      children: [renderMessagingAboveStepContent(), /*#__PURE__*/_jsx(Suspense, {
        fallback: /*#__PURE__*/_jsx(UILoadingSpinner, {
          grow: true,
          size: "extra-small"
        }),
        children: /*#__PURE__*/_jsx(StepViewComponent, {})
      })]
    })
  }));
};